import { render, staticRenderFns } from "./landing-page.vue?vue&type=template&id=a276d3dc"
import script from "./landing-page.vue?vue&type=script&lang=ts"
export * from "./landing-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports